import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../../config/axiosInterceptor";
import { CreateTakeoffByCompanyIdType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const createTakeoffByCompanyId = (
  id: string,
  payload: CreateTakeoffByCompanyIdType
): Promise<AxiosResponse<CreateTakeoffByCompanyIdType>> => {
  return axios.put(`${baseURL}createTakeoffByCompanyId/${id}`, payload);
};

export const deleteTakeoffById = (
  id: string
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteTakeoffById/${id}`);
};

export const deleteTakeoff = (
  takeOffIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteTakeoff`, { data: takeOffIds });
};
